import React, { FunctionComponent, useState } from 'react';
import type { BrandHeading } from '../../../types/brand';
import { CoverThumbsSliderShow } from '../../molecules/coverThumbsSliderShow';

type Props = {
  brandHeadData: BrandHeading;
  instagramIcon: string;
  noimage: string;
  dataCategory: string;
  dataValue: any;
  isStopped: boolean;
  isStoppedFv?: boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  brandHeadData,
  instagramIcon,
  noimage,
  dataCategory,
  dataValue,
  isStopped,
  isStoppedFv,
}) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const shouldShowStoppedFv = isStoppedFv && isStopped;
  const descriptionClassName = [
    'brand-heading__description',
    shouldShowStoppedFv && 'stopped',
    shouldShowStoppedFv && isDescriptionExpanded && 'is-expanded'
  ].filter(Boolean).join(' ');

  return (
    <div className={`brand-heading ${shouldShowStoppedFv ? 'stopped' : ''}`}>
      {!shouldShowStoppedFv &&
        <CoverThumbsSliderShow
          images={brandHeadData.images}
          noimage={noimage}
          recruitmentTitle={brandHeadData.name.full}
          isScouted={false}
          isApplied={false}
        />
      }
      <div className="brand-heading__content">
        <div className="brand-heading__title-wrapper">
          <div className="brand-heading__title">
            {brandHeadData.name.truncated} | {brandHeadData.name.full}
          </div>
          {brandHeadData.instagramUrl && (
            <a
              href={brandHeadData.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="brand-heading__instagram gtm-instagram-view-count"
              data-event-name='instagram on screen'
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue}
            >
              <img src={instagramIcon} alt="Instagram" className="brand-heading__instagram-icon" />
            </a>
          )}
        </div>
        <div className={descriptionClassName}>
          <div dangerouslySetInnerHTML={{ __html: brandHeadData.description?.full ?? '' }} />
        </div>
        {shouldShowStoppedFv && (
          <button
            type="button"
            className="brand-heading__description-toggle"
            aria-expanded={isDescriptionExpanded}
            onClick={() => setIsDescriptionExpanded((prev) => !prev)}
          >
            {isDescriptionExpanded ? '閉じる' : 'もっと見る'}
            <svg xmlns="http://www.w3.org/2000/svg" className={`${isDescriptionExpanded ? 'is-open' : ''}`} height="20px" viewBox="0 -960 960 960" width="20px" fill="#065FD4"><path d="M480-346.85 253.85-573 291-610.15l189 189 189-189L706.15-573 480-346.85Z"/></svg>
          </button>
        )}
      </div>
    </div>
  );
};
